export enum RouteLayerType {
  App = 'app',
  Settings = 'settings',
  Support = 'support',
  Billing = 'billing',
}
